import { collection, doc, onSnapshot } from "firebase/firestore";
import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { About_Type } from "../model";
import Loading from "../components/Loading";

function AboutPage() {
  const [about, setAbout] = useState<About_Type>();
  const [loading, setLoading] = useState<boolean>(false);

  const [currentText, setCurrentText] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (about?.title) {
      if (currentIndex < about?.title.length) {
        const timeout = setTimeout(() => {
          setCurrentText((prevText) => prevText + about?.title[currentIndex]);
          setCurrentIndex((prevIndex) => prevIndex + 1);
        }, 200);

        return () => clearTimeout(timeout);
      }
    }
  }, [about?.title, currentIndex]);

  useEffect(() => {
    setLoading(true);
    onSnapshot(
      doc(collection(db, "about"), "about"),
      (snapshot) => {
        setAbout(snapshot.data() as About_Type);
        setLoading(false);
      },
      (error) => {
        console.log(error);
        setLoading(false);
      }
    );
  }, []);

  return (
    <section className="bg-gray-100 py-10">
      <div className="container mx-auto px-4">
        {!about || loading ? (
          <Loading />
        ) : (
          <div className="flex flex-col items-center">
            {/* simple avatar */}
            <img
              src={about.image}
              alt="Profile"
              className="rounded-full h-32 w-32 mb-5"
            />
            <h2 className="text-xl sm:text-2xl md:text-3xl font-bold mb-2">
              {about.name}
            </h2>
            <p
              id="title"
              className="text-gray-600 text-center text-sm sm:text-md md:text-lg mb-5 flex gap-1"
            >
              {currentText}
              <p className="text-gray-800 animate-animate-ping">|</p>
            </p>
            <div className="max-w-3xl mx-auto">
              <p className="text-gray-800 text-sm sm:text-md md:text-lg leading-relaxed text-justify">
                {about.bio}
              </p>
            </div>
            <div className="max-w-3xl mx-auto mt-8">
              <h3 className="text-xl sm:text-2xl font-bold mb-2 p-4">
                Key Achievements
              </h3>
              <ul className="list-disc list-inside text-gray-800">
                {about.keyAchivments.map((achievement, index) => (
                  <li
                    className="bg-white mb-4 px-5 py-2 rounded-md shadow-md hover:scale-[1.02] duration-300 transition-all ease-in-out"
                    key={index}
                  >
                    {achievement}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}

export default AboutPage;
